import type { RootState } from '../rootReducer';

export const selectSidebarIsOpen = (state: RootState) => state.ui.showSidebar;
export const selectIsErrorPage = (state: RootState) => state.ui.isErrorPage;
export const selectShouldShowRegistrationBonus = (state: RootState) => state.ui.shouldShowRegistrationBonus;
export const selectAviatrixPopupIsOpen = (state: RootState) => state.ui.showAviatrixPopup;
export const selectShowTabletSportSidebar = (state: RootState) => state.ui.showTabletSportSidebar;
